import http from '../utils/http';

import * as endpoints from '../constants/endpoints';

export const getCurrentUserInfo = async () => {
  const { data } = await http.get(endpoints.FETCH_CURRENT_USER);

  return data;
};
